import { Navigate, useLocation } from 'react-router';
import type { KeepLocationRedirectProps } from './types';

/**
 * A redirect that **keeps the query string and what the router carried**, which a plain
 * `<Navigate to>` drops. For an address that moved but whose parameters still mean what
 * they meant, such as `?kind=gitlab` and the repository address a connection came from.
 */
export const KeepLocationRedirect = ({ to }: KeepLocationRedirectProps) => {
  const location = useLocation();
  const { search } = location;
  const state: unknown = location.state;

  return <Navigate to={{ pathname: to, search }} state={state} replace />;
};
